
import Component from './component';
import createComponentFactory from '../createComponent';
import Swiper from 'swiper/dist/js/swiper'


class HeaderLink extends Component {

  constructor(element, context, options) {
    super(element, context, options);

    this._sliderContxt = null;
  }

  didRegisterComponent() {

    if(!this._sliderContxt) {
      this._sliderContxt = new Swiper(this.element, {
        loop: true,
        speed: 850,
        direction: 'vertical',
        autoplay: {
          delay: 5000
        },
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        }
      });
    }
  }

  didUnregisterComponent() {
    if(this._sliderContxt) {
      this._sliderContxt.destroy();
      this._sliderContxt = null;
    }
  }
}


export default createComponentFactory(HeaderLink);



// WEBPACK FOOTER //
// ./src/js/app/component/headerLink.js